export default function fnGetScheduleModeName(mode) {
    return {
        ONLINE: 'En línea',
        ONSITE: 'Presencial',
    }[mode]
}
